import React from "react"
import Ajax from "../../../../Ajax"
import { Alert, AlertModal, DisplayValue } from "../../../.."
import { Button } from "@mui/material"
import { Icons } from "../../../../misc/Icons"
import QuestionnaireDetails from "../../../views/questionnaire/QuestionnaireDetails"
import QuestionnaireSelectMultipleField from "../../questionnaire/QuestionnaireSelectMulitpleField"
import { store } from "../../../../stores/Store"
import ViewQuestionnaire from "../../../views/questionnaire/ViewQuestionnaire"


export default function EnquiryDataSourcesFormSection ({
    hidden,
    enquiry,
    onCancel = () => {},
    onSubmit = (data) => {},
}) {

    const [questionnaireUidArray, setQuestionnaireUidArray] = React.useState([])

    var enquiryStatus = enquiry?.statuses.find(status => status.selected)?.code
    var relevantTemplateKeys = store.QuestionnaireStore.setSearchTemplateKeysByStatusId(enquiryStatus)

    if (hidden) return <></>

    return (
        <div>
            <h2>Create Enquiry<span style={{color: "grey", fontWeight: 400}}> - Data Sources</span></h2>

            {relevantTemplateKeys?.length ? (
                <div>
                    <p>The relevant Questionnaire types for this Enquiry are:</p>
                    
                    {relevantTemplateKeys.map((key, i) => (
                        <div key={i} style={{display: "flex", marginLeft: "10px", gap: "6px", alignItems: "center", color: "grey"}}>
                            <Icons.Questionnaire style={{fontSize: "14px"}} />
                            <small>{DisplayValue("template_key", key)}</small>
                        </div>
                    ))}

                    <div style={{width: "100%", height: "0.5px", backgroundColor: "#a7a7a7", margin: "10px auto 0", boxSizing: "border-box"}}></div>
                </div>
            ) : null}

            <QuestionnaireSelectMultipleField
                value={questionnaireUidArray}
                onChange={(uidArray) => setQuestionnaireUidArray(uidArray)}
                // onRowClick={(questionnaireUid) => previewQuestionnaire(questionnaireUid)}
                onRowClick={(uid) => AlertModal({width: "700px", body: <ViewQuestionnaire uid={uid} />})}
            />

            <div className="form-buttons">
                <Button
                    className="btn btn-sm"
                    onClick={() => onCancel()}>
                    Back
                </Button>

                <Button
                    className="btn btn-sm"
                    variant="contained"
                    color="success"
                    onClick={() => onSubmit(questionnaireUidArray)}>
                    Next
                </Button>
            </div>
        </div>
    )
}


